import React, {Fragment, useContext, useState} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";
import LabelWithInfo from "../../../components/LabelWithInfo/LabelWithInfo";
import FormatUtils from "../../../utils/FormatUtils";

function CalculationSummary(props) {

    const customerContext = useContext(CustomerTypeContext);
    const isCompany = isCustomerCompany(customerContext);

    const insuranceAmount = props.insuranceData
        ? (isCompany ? props.insuranceData.companyInsurance : props.insuranceData.consumerInsurance)
        : null;
    const insuranceSuffix = isCompany ? "netto" : "brutto";
    const insurancePriceText = insuranceAmount != null
        ? Math.round(insuranceAmount).toLocaleString('pl-PL') + " zł " + insuranceSuffix
        : "indywidualna wycena";

    const gapSuffix = isCompany ? "netto" : "brutto";
    const gapPriceText = props.gapData && props.gapData.oneTimePremium != null
        ? props.gapData.oneTimePremium.toLocaleString('pl-PL') + " zł " + gapSuffix
        : "indywidualna wycena";
    const [expanded, setExpanded] = useState(false);

    let brakLabel = (<span style={{color: "red"}}>brak</span>);

    let acOcValue = props.isIndividualInsurance ? "indywidualnie" : (props.calculationResult.ocAcInsuranceNet === 0 ?
        (brakLabel) : ((isCompany ?
            props.calculationResult.ocAcInsuranceNet : props.calculationResult.ocAcInsuranceGross) + " zł"));

    let gapValue = props.calculationResult.gapInsuranceNet === 0 ?
        (brakLabel) : ((isCompany ?
            props.calculationResult.gapInsuranceNet : props.calculationResult.gapInsuranceGross) + " zł");

    let inPrice = props.isGwarancjaZwrotuActive ? "w cenie" : brakLabel;

    const brakLabelFormatter = (condition, value, isLabel) => {
        if (condition === brakLabel) {
            if (props.offer.hasReturnGuarantee) {
                if (isLabel) return value; else return brakLabel;
            } else return '';
        } else return value;
    }

    return (
        <Fragment>
            <div className="calc__summary-header">
                <p className="calc__summary-title">Podsumowanie</p>
                <button type="button" className="calc__summary-toggle" onClick={() => setExpanded(e => !e)}>
                    {expanded ? "Zwiń składowe" : "Rozwiń składowe"}
                    <span className={"calc__summary-arrow" + (expanded ? " calc__summary-arrow--up" : "")}>›</span>
                </button>
            </div>

            {expanded && (
                <div className="calc__summary-rows">
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Okres leasingu</span>
                        <span className="calc__row-change" onClick={props.changeContractLength}>Zmień</span>
                        <span className="calc__row-value">{props.calculationResult.numberOfInstallments} m-cy</span>
                    </div>
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Opłata wstępna</span>
                        <span className="calc__row-change" onClick={props.changeInitialFee}>Zmień</span>
                        <span className="calc__row-value">
                            {isCompany
                                ? FormatUtils.formatMoney(props.calculationResult.initialFeeValueNet, 0)
                                : FormatUtils.formatMoney(props.calculationResult.initialFeeValueGross, 0)}
                        </span>
                    </div>
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Wykup</span>
                        <span className="calc__row-change" onClick={props.changeBuyoutValue}>Zmień</span>
                        <span className="calc__row-value">
                            {isCompany
                                ? FormatUtils.formatMoney(props.calculationResult.buyoutValueNet, 0)
                                : FormatUtils.formatMoney(props.calculationResult.buyoutValueGross, 0)}
                        </span>
                    </div>

                    {props.isNew && props.allInsuranceVisible && <>
                        <div className="calc__summary-row">
                            <span className="calc__row-label">Rata leasingu</span>
                            <span className="calc__row-value">
                                {isCompany
                                    ? FormatUtils.formatMoney(props.calculationResult.installmentNet, 0)
                                    : FormatUtils.formatMoney(props.calculationResult.installmentGross, 0)}
                            </span>
                        </div>
                        <div className="calc__summary-row calc__summary-row--multiline">
                            <span className="calc__row-label">Ubezpieczenie</span>
                            <span className="calc__row-sub">
                                {brakLabelFormatter(acOcValue, props.isIndividualInsurance ? "OC/AC" : "OC/AC na " + props.calculationParameters.insuranceLength + " miesięcy", true)}<br/>
                                GAP na cały okres umowy<br/>
                                {brakLabelFormatter(inPrice, "Assistance", true)}
                            </span>
                            <span className="calc__row-value calc__row-value--multiline">
                                {brakLabelFormatter(acOcValue, acOcValue)}<br/>
                                {gapValue}<br/>
                                {brakLabelFormatter(inPrice, inPrice)}
                            </span>
                        </div>
                        {props.offer.hasReturnGuarantee && <>
                            <div className="calc__summary-row">
                                <span className="calc__row-label"><LabelWithInfo infoCode="gwarancja-zwrotu"/></span>
                                <span className="calc__row-value">{inPrice}</span>
                            </div>
                            <div className="calc__summary-row">
                                <span className="calc__row-label"><LabelWithInfo infoCode="karta-serwisowa"/></span>
                                <span className="calc__row-value">{inPrice}</span>
                            </div>
                            <div className="calc__summary-row">
                                <span className="calc__row-label"><LabelWithInfo infoCode="gps"/></span>
                                <span className="calc__row-value">{inPrice}</span>
                            </div>
                        </>}
                        <div className="calc__summary-row">
                            <span className="calc__row-label"><LabelWithInfo infoCode="rejestracja-auta"/></span>
                            <span className="calc__row-value">w cenie</span>
                        </div>
                    </>}

                    {!props.isNew && props.allInsuranceVisible &&
                        <div className="calc__summary-row">
                            <span className="calc__row-label">Ubezpieczenie</span>
                            <span className="calc__row-sub">GAP na cały okres umowy</span>
                            <span className="calc__row-value">{gapValue}</span>
                        </div>
                    }
                    {props.drivePlusInstallment != null && (
                        <div className="calc__summary-row">
                            <span className="calc__row-label">Pakiet korzyści</span>
                            <span className="calc__row-value">{FormatUtils.formatMoney(props.drivePlusInstallment)}/mies.</span>
                        </div>
                    )}
                    {props.insuranceChecked && (
                        <div className="calc__summary-row">
                            <span className="calc__row-label">Ubezpieczenie OC/AC</span>
                            <span className="calc__row-value">{insurancePriceText}</span>
                        </div>
                    )}
                    {props.gapChecked && (
                        <div className="calc__summary-row">
                            <span className="calc__row-label">GAP</span>
                            <span className="calc__row-value">{gapPriceText}</span>
                        </div>
                    )}
                </div>
            )}
        </Fragment>
    );
}

export default CalculationSummary;
